import { render, staticRenderFns } from "./FieldEdit.vue?vue&type=template&id=13c6848e&"
import script from "./FieldEdit.vue?vue&type=script&lang=ts&"
export * from "./FieldEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports